package com.devi3east.bashbuddy.features.events.feed.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.devi3east.bashbuddy.features.events.common.EventRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class EventFeedViewModel(
    private val repository: EventRepository
) : ViewModel() {

    private val _uiState = MutableStateFlow(EventFeedUiState())
    val uiState: StateFlow<EventFeedUiState> = _uiState

    fun getEventsList() {
        viewModelScope.launch {
            _uiState.update {
                it.copy(
                    isLoading = true,
                    errorMessage = null
                )
            }

            repository.getEventsList()
                .onSuccess { response ->
                    val filteredEvents = response.events.filter {
                        it.publishedAtInstant != null
                    }

                    _uiState.update {
                        it.copy(
                            isLoading = false,
                            hasCompletedInitialLoad = true,
                            eventsList = filteredEvents,
                            errorMessage = null
                        )
                    }
                }
                .onFailure { e ->
                    _uiState.update {
                        it.copy(
                            isLoading = false,
                            hasCompletedInitialLoad = true,
                            errorMessage = e.message ?: "Unknown error occurred"
                        )
                    }
                }
        }
    }

    fun getUserCount() {
        viewModelScope.launch {
            val count = repository.getUserCount()
            _uiState.update { it.copy(userCount = count) }
        }
    }

}